import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const ACTIONS = ["Masuk", "Keluar", "Tambah", "Ubah", "Arsipkan", "Verifikasi", "Ekspor"];

export const AuditLog = () => {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [action, setAction] = useState("");
  useEffect(() => {
    const t = setTimeout(() => api(`/audit-logs?q=${encodeURIComponent(q)}&action=${encodeURIComponent(action)}`).then(setRows).catch((e) => toast.error(e.message)), 250);
    return () => clearTimeout(t);
  }, [q, action]);
  return (
    <div data-testid="audit-log-page">
      <div className="page-heading compact"><div><p className="eyebrow">KEAMANAN & JEJAK DATA</p><h1>Log aktivitas</h1><p className="muted">Riwayat aktivitas pengguna dan perubahan data di SIDEPAS.</p></div></div>
      <div className="toolbar">
        <div className="search"><Search size={17} /><input data-testid="audit-search-input" placeholder="Cari pengguna, modul, atau detail…" value={q} onChange={(e) => setQ(e.target.value)} /></div>
        <select className="audit-select" data-testid="audit-action-filter" value={action} onChange={(e) => setAction(e.target.value)}>
          <option value="">Semua aksi</option>{ACTIONS.map((a) => <option key={a}>{a}</option>)}
        </select>
        <span className="result-count" data-testid="audit-count">{rows.length} aktivitas</span>
      </div>
      <section className="panel table-panel">
        <table><thead><tr><th>Waktu</th><th>Pengguna</th><th>Peran</th><th>Aksi</th><th>Modul</th><th>Detail</th></tr></thead>
          <tbody>{rows.map((r) => (
            <tr key={r.id} data-testid={`audit-row-${r.id}`}>
              <td>{new Date(r.created_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "short" })}</td>
              <td><b>{r.name}</b><small className="table-sub">@{r.username}</small></td>
              <td>{r.role === "admin" ? "Administrator" : "Operator"}</td>
              <td><span className={`status ${r.action === "Masuk" || r.action === "Keluar" ? "waiting" : "verified"}`}>{r.action}</span></td>
              <td>{r.entity}</td><td>{r.detail}</td>
            </tr>))}
          </tbody></table>
        {!rows.length && <div className="empty">Belum ada aktivitas tercatat.</div>}
      </section>
    </div>
  );
};
